export default __webpack_public_path__ + "static/8-reports-8f8c312dae94b83eb661b90428ede6f0.jpg";